<template>
  <div :class="clsx('possibilities-list', { 'animations-disabled': !animationEnabled })">
    <div class="possibilities-list__row">
      <PossibilityBlock
        :title="this.getListBlock('promo', 'possibilities-list')[2].key"
        :subtitle="this.getListBlock('promo', 'possibilities-list')[2].value"
        class="possibilities-list__item possibilities-list__item--tools"
      >
        <HammerImage />
      </PossibilityBlock>
      <PossibilityBlock
        :title="this.getListBlock('promo', 'possibilities-list')[1].key"
        :subtitle="this.getListBlock('promo', 'possibilities-list')[1].value"
        class="possibilities-list__item possibilities-list__item--team"
      >
        <BustsInSilhouetteImage />
      </PossibilityBlock>
      <PossibilityBlock
        :title="this.getListBlock('promo', 'possibilities-list')[0].key"
        :subtitle="this.getListBlock('promo', 'possibilities-list')[0].value"
        class="possibilities-list__item possibilities-list__item--analytics"
      >
        <BarChartImage />
      </PossibilityBlock>
    </div>
    <div class="possibilities-list__row">
      <PossibilityBlock
        :title="this.getListBlock('promo', 'possibilities-list')[4].key"
        :subtitle="this.getListBlock('promo', 'possibilities-list')[4].value"
        class="possibilities-list__item possibilities-list__item--propositions"
      >
        <KeyImage />
      </PossibilityBlock>
      <PossibilityBlock
        :title="this.getListBlock('promo', 'possibilities-list')[3].key"
        :subtitle="this.getListBlock('promo', 'possibilities-list')[3].value"
        class="possibilities-list__item possibilities-list__item--calendar"
      >
        <SpiralCalendarImage />
      </PossibilityBlock>
    </div>
    <div class="possibilities-list__row">
      <PossibilityBlock
        :title="this.getListBlock('promo', 'possibilities-list')[5].key"
        :subtitle="this.getListBlock('promo', 'possibilities-list')[5].value"
        class="possibilities-list__item possibilities-list__item--control"
      >
        <MagImage />
      </PossibilityBlock>
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import PossibilityBlock from '../../possibility-block';
import { textBlock } from '@/entities/text-block';
import {
  BarChartImage,
  BustsInSilhouetteImage,
  HammerImage,
  KeyImage,
  MagImage,
  SpiralCalendarImage
} from '@/shared/ui/promo';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [ textBlock ],
  components: {
    HammerImage, KeyImage, SpiralCalendarImage, MagImage, BustsInSilhouetteImage, BarChartImage, PossibilityBlock
  },
  methods: { clsx },
};
</script>

<style scoped lang="scss">
.possibilities-list {
  position: absolute;
  bottom: 40px;
  width: 100%;

  &__row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;

    @media (max-width: 600px) {
      flex-direction: column;
    }
  }

  &__item {
    transform: scale(0);
    opacity: 0;
    animation: possibilities-item-animation 0.5s linear forwards;
    animation-play-state: paused;

    &--analytics {
      animation-delay: 3s;
    }

    &--team {
      animation-delay: 3.5s;
    }

    &--tools {
      animation-delay: 4s;
    }

    &--calendar {
      margin-right: 20%;
      animation-delay: 4.5s;
    }

    &--propositions {
      margin-left: 20%;
      animation-delay: 5s;
    }

    &--control {
      animation-delay: 5.5s;
    }
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .possibilities-list__item {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes possibilities-item-animation {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
